import { disableScroll, enableScroll } from "../../components/_helpers.js";

export default class SortingWindow {
    private mobileSorting: HTMLElement | null = document.querySelector('.mobile-sorting');
    private closeWindowButton: HTMLElement | null = document.querySelector('.close-mobile-sorting');
    private openMobileSortingButtons: NodeListOf<HTMLElement> | null = document.querySelectorAll('.open-mobile-sorting');

    private orderByWrapper: HTMLElement | null = null;
    private orderBySelect: HTMLSelectElement | null | undefined = null;
    private mobileOrderByWrapper: HTMLElement | null = null;

    private prderPageWrapper: HTMLElement | null = null;
    private perPageLinks: NodeListOf<HTMLAnchorElement> | null | undefined = null;
    private mobilePerPageByWrapper: HTMLElement | null = null;


    async init(): Promise<void> {

        await this.initVariables();
        await this.filterWindowEvents();
        await this.createOrderByButtons();
        await this.createPerPageButtons();

        jQuery(document).on('ajaxComplete', () => {
            this.initVariables();
            this.cleanUp();
            this.createOrderByButtons();
            this.createPerPageButtons();
        });
    }

    async initVariables(): Promise<void> {
        //desktop orderby
        this.orderByWrapper = document.querySelector('.orderby-placeholder');
        //desktop orderby select
        this.orderBySelect = this.orderByWrapper?.querySelector('select.orderby');
        //mobile orderby container
        this.mobileOrderByWrapper = document.querySelector('.mobile-orderby-placeholder');

        //desktop per page
        this.prderPageWrapper = document.querySelector('.per-page');
        //desktop per page links
        this.perPageLinks = this.prderPageWrapper?.querySelectorAll('a');
        //mobile per page container
        this.mobilePerPageByWrapper = document.querySelector('.mobile-perpage-placeholder');
    }

    async cleanUp(): Promise<void> {
        while (this.mobileOrderByWrapper?.firstChild) {
            this.mobileOrderByWrapper.removeChild(this.mobileOrderByWrapper.firstChild);
        }
        while (this.mobilePerPageByWrapper?.firstChild) {
            this.mobilePerPageByWrapper.removeChild(this.mobilePerPageByWrapper.firstChild);
        }
    }

    async createOrderByButtons(): Promise<void> {

        const options = this.orderBySelect?.querySelectorAll('option');
        const radioButtons = document.createElement('ul') as HTMLElement;
        radioButtons.classList.add('mobile-orderby-list');

        options?.forEach((option: HTMLOptionElement) => {
            const listElement = document.createElement('li') as HTMLLIElement;
            const label = document.createElement('label') as HTMLLabelElement;
            const input = document.createElement('input') as HTMLInputElement;

            input.type = 'radio';
            input.name = 'orderby';
            input.value = option.value;
            input.id = option.value;
            input.checked = option.selected;
            input.addEventListener('change', () => {
                if (this.orderBySelect) {
                    this.orderBySelect.value = option.value;
                    this.orderBySelect.dispatchEvent(new Event('change'));
                }
                this.closeWindow();
                this.scrollResultsIntoView();
            });

            label.htmlFor = option.value;
            listElement.appendChild(input);
            label.appendChild(document.createTextNode(option.text));
            listElement.appendChild(label);
            radioButtons.appendChild(listElement);
        });

        this.mobileOrderByWrapper?.appendChild(radioButtons);

    }

    async createPerPageButtons(): Promise<void> {
        if (!this.prderPageWrapper || !this.perPageLinks) return;

        const radioButtons = document.createElement('ul') as HTMLElement;
        radioButtons.classList.add('mobile-perpage-list');

        this.perPageLinks?.forEach((link: HTMLAnchorElement, index: Number) => {
            const listElement = document.createElement('li') as HTMLLIElement;
            const label = document.createElement('label') as HTMLLabelElement;
            const input = document.createElement('input') as HTMLInputElement;

            input.type = 'radio';
            input.name = 'per-page';
            input.value = index.toString();
            input.id = `per-page-${index}`;
            input.checked = link.classList.contains('active');

            input.addEventListener('change', () => {
                link.click();
                this.closeWindow();
                this.scrollResultsIntoView();
            });

            label.htmlFor = input.id;
            listElement.appendChild(input);
            label.appendChild(document.createTextNode(link.text));
            listElement.appendChild(label);
            radioButtons.appendChild(listElement);
        });

        this.mobilePerPageByWrapper?.appendChild(radioButtons);

    }

    async filterWindowEvents(): Promise<void> {

        if (!this.openMobileSortingButtons) return;

        this.openMobileSortingButtons.forEach((button: HTMLElement) => {
            button.addEventListener('click', async () => {
                await this.openWindow();
            });
        });

        if (!this.closeWindowButton)
            return;

        this.closeWindowButton.addEventListener('click', async () => {
            await this.closeWindow();
        });
    }

    async scrollResultsIntoView(): Promise<void> {
        const results: HTMLElement | null = document.querySelector('.products .scroll-offset');

        if (!results) return;

        results.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    async toggleWindow(): Promise<void> {
        if (!this.mobileSorting) return;

        if (this.mobileSorting.classList.contains('open')) {
            await this.closeWindow();
        } else {
            await this.openWindow();
        }
    }

    async closeWindow(): Promise<void> {
        if (!this.mobileSorting) return;
        this.mobileSorting.classList.remove('open');
        enableScroll();
    }

    async openWindow(): Promise<void> {
        if (!this.mobileSorting) return;
        this.mobileSorting.classList.add('open');
        await disableScroll();
    }
}